// Import Howler.js library
import { Howl, Howler } from 'howler';

// Expose Howler globally
window.Howl = Howl;
window.Howler = Howler;
